import * as d3 from 'd3';
import { useEffect, useRef } from 'react';

const Legend_line_shape = (props) => {

    const legendLineShapeRef = useRef();

    if(props.view === 4 && props.arg === 'shape'){
        var graphWidthActual = 300;
        var graphHeightActual = 160;
    } else {
        var graphWidthActual = 300;
        var graphHeightActual = 105;
    }

    const draw = () => {

        const margin = {top: 50, right: 50, bottom: 50, left: 50};

        const graphWidth = graphWidthActual - margin.left - margin.right;
        const graphHeight = graphHeightActual - margin.top - margin.bottom;


        const legendBar = d3.select(legendLineShapeRef.current);

        return {legendBar, margin, graphWidth, graphHeight}
    };

    const update = (legendBar, graphWidth, graphHeight) => {
    const color = "black";
    if(props.view === 2){
        const label_data = [{"label":"จำนวนผู้เสียชีวิตจริง (Observed Death)"},{"label":"จำนวนตายที่คาด (Expected Death)"}];

        legendBar.append('line')
            .style("stroke", color)
            .style("stroke-width", 3)
            .attr("x1", 0)
            .attr("y1", 20)
            .attr("x2", 30)
            .attr("y2", 20);
        
        legendBar.append('line')
            .style("stroke", color)
            .style("stroke-width", 3)
            .style("stroke-dasharray", ("5, 5"))
            .attr("x1", 0)
            .attr("y1", 40)
            .attr("x2", 30)
            .attr("y2", 40);
        
        legendBar.selectAll('.label')
            .data(label_data)
            .join('text')
            .attr('class', 'label')
            .attr("x", (d, i) => 40)
            .attr("y", (d, i) => 25+20*i)
            .text(d => d.label);

        } else if(props.view === 3){
            // console.log(props.selectedGender);
            if((props.selectedGender.includes('ชาย') && props.selectedGender.includes('หญิง')) && !(props.selectedGender.includes('รวม'))){

                const label_data = [{"label":"เพศชาย"},{"label":"เพศหญิง"}];
                legendBar.selectAll(".point_label_male")
                    .remove();

                legendBar.selectAll(".point_label_female")
                    .remove();

                legendBar.selectAll(".point_label_all")
                    .remove();

                legendBar.selectAll(".point_label_all_inner")
                    .remove();

                legendBar.selectAll(".gender_line")
                    .remove();

                legendBar.selectAll(".label")
                    .remove();

                legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 20)
                    .attr("x2", 40)
                    .attr("y2", 20);

                legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    // .style("stroke-dasharray", ("5, 5"))
                    .attr("x1", 0)
                    .attr("y1", 40)
                    .attr("x2", 40)
                    .attr("y2", 40);

                legendBar.append('circle')
                    .attr('class', 'point_label_male')
                    .attr('fill', "black")
                    .attr('r', 6)
                    .attr('cx', 20)
                    .attr('cy', 20);
        
                legendBar.append('circle')
                        .attr('class', 'point_label_female')
                        .style("stroke", "black")
                        .attr('r', 5)
                        .style("fill", "white")
                        .style("stroke-width", "2px")
                        .attr('cx', 20)
                        .attr('cy', 40);

                legendBar.selectAll('.label')
                    .data(label_data)
                    .join('text')
                    .attr('class', 'label')
                    .attr("x", (d, i) => 50)
                    .attr("y", (d, i) => 25+20*i)
                    .text(d => d.label);
            } else if((props.selectedGender.includes('ชาย') || props.selectedGender.includes('หญิง')) && !(props.selectedGender.includes('รวม'))){
                legendBar.selectAll(".point_label_male")
                .remove();

                legendBar.selectAll(".point_label_female")
                    .remove();

                legendBar.selectAll(".point_label_all")
                    .remove();

                legendBar.selectAll(".point_label_all_inner")
                    .remove();

                legendBar.selectAll(".gender_line")
                    .remove();

                legendBar.selectAll(".label")
                    .remove();

                legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 20)
                    .attr("x2", 40)
                    .attr("y2", 20);

                if(props.selectedGender.includes('ชาย')){
                    var label_data = [{"label":"เพศชาย"}];

                    legendBar.append('circle')
                    .attr('class', 'point_label_male')
                    .attr('fill', "black")
                    .attr('r', 6)
                    .attr('cx', 20)
                    .attr('cy', 20);
                } else {
                    var label_data = [{"label":"เพศหญิง"}];
                    legendBar.append('circle')
                    .attr('class', 'point_label_female')
                    .style("stroke", "black")
                    .attr('r', 5)
                    .style("fill", "white")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 20);
                }

                legendBar.selectAll('.label')
                    .data(label_data)
                    .join('text')
                    .attr('class', 'label')
                    .attr("x", (d, i) => 50)
                    .attr("y", (d, i) => 25+20*i)
                    .text(d => d.label);
            } else if(props.selectedGender.includes('รวม') && props.selectedGender.length === 1){
                legendBar.selectAll(".point_label_male")
                .remove();

                legendBar.selectAll(".point_label_female")
                    .remove();

                legendBar.selectAll(".point_label_all")
                    .remove();

                legendBar.selectAll(".point_label_all_inner")
                    .remove();

                legendBar.selectAll(".gender_line")
                    .remove();

                legendBar.selectAll(".label")
                    .remove();
                
                legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 20)
                    .attr("x2", 40)
                    .attr("y2", 20);

                var label_data = [{"label":"รวมทั้งสองเพศ"}];

                legendBar.append('circle')
                .attr('class', 'point_label_all')
                .style("stroke", "black")
                .attr('r', 5)
                .style("fill", "white")
                .style("stroke-width", "2px")
                .attr('cx', 20)
                .attr('cy', 20);

                legendBar.append('circle')
                .attr('class', 'point_label_all_inner')
                .style("stroke", "black")
                .attr('r', 1)
                .style("fill", "black")
                .style("stroke-width", "2px")
                .attr('cx', 20)
                .attr('cy', 20);
                
                legendBar.selectAll('.label')
                    .data(label_data)
                    .join('text')
                    .attr('class', 'label')
                    .attr("x", (d, i) => 50)
                    .attr("y", (d, i) => 25+20*i)
                    .text(d => d.label);
            } else if(props.selectedGender.includes('รวม') && props.selectedGender.length >= 1){
                legendBar.selectAll(".point_label_male")
                .remove();

                legendBar.selectAll(".point_label_female")
                    .remove();

                legendBar.selectAll(".point_label_all")
                    .remove();

                legendBar.selectAll(".point_label_all_inner")
                    .remove();

                legendBar.selectAll(".gender_line")
                    .remove();

                legendBar.selectAll(".label")
                    .remove();
                
                if(props.selectedGender.includes('ชาย') && !(props.selectedGender.includes('หญิง'))){
                    var label_data = [{"label":"รวมทั้งสองเพศ"},{"label":"เพศชาย"}];

                    legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 20)
                    .attr("x2", 40)
                    .attr("y2", 20);

                    legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 40)
                    .attr("x2", 40)
                    .attr("y2", 40);

                    legendBar.append('circle')
                    .attr('class', 'point_label_all')
                    .style("stroke", "black")
                    .attr('r', 5)
                    .style("fill", "white")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 20);
    
                    legendBar.append('circle')
                    .attr('class', 'point_label_all_inner')
                    .style("stroke", "black")
                    .attr('r', 1)
                    .style("fill", "black")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 20);

                    legendBar.append('circle')
                    .attr('class', 'point_label_male')
                    .attr('fill', "black")
                    .attr('r', 6)
                    .attr('cx', 20)
                    .attr('cy', 40);
                } else if(!(props.selectedGender.includes('ชาย')) && props.selectedGender.includes('หญิง')){
                    var label_data = [{"label":"รวมทั้งสองเพศ"},{"label":"เพศหญิง"}];

                    legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 20)
                    .attr("x2", 40)
                    .attr("y2", 20);

                    legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 40)
                    .attr("x2", 40)
                    .attr("y2", 40);

                    legendBar.append('circle')
                    .attr('class', 'point_label_all')
                    .style("stroke", "black")
                    .attr('r', 5)
                    .style("fill", "white")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 20);
    
                    legendBar.append('circle')
                    .attr('class', 'point_label_all_inner')
                    .style("stroke", "black")
                    .attr('r', 1)
                    .style("fill", "black")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 20);

                    legendBar.append('circle')
                    .attr('class', 'point_label_female')
                    .style("stroke", "black")
                    .attr('r', 5)
                    .style("fill", "white")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 40);
                } else {
                    var label_data = [{"label":"รวมทั้งสองเพศ"},{"label":"เพศชาย"},{"label":"เพศหญิง"}];

                    legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 20)
                    .attr("x2", 40)
                    .attr("y2", 20);

                    legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 40)
                    .attr("x2", 40)
                    .attr("y2", 40);

                    legendBar.append('line')
                    .attr('class', 'gender_line')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 60)
                    .attr("x2", 40)
                    .attr("y2", 60);

                    legendBar.append('circle')
                    .attr('class', 'point_label_all')
                    .style("stroke", "black")
                    .attr('r', 5)
                    .style("fill", "white")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 20);
    
                    legendBar.append('circle')
                    .attr('class', 'point_label_all_inner')
                    .style("stroke", "black")
                    .attr('r', 1)
                    .style("fill", "black")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 20);

                    legendBar.append('circle')
                    .attr('class', 'point_label_male')
                    .style("stroke", "black")
                    .attr('r', 5)
                    .style("fill", "black")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 40);

                    legendBar.append('circle')
                    .attr('class', 'point_label_female')
                    .style("stroke", "black")
                    .attr('r', 5)
                    .style("fill", "white")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 60);
                }

                legendBar.selectAll('.label')
                    .data(label_data)
                    .join('text')
                    .attr('class', 'label')
                    .attr("x", (d, i) => 50)
                    .attr("y", (d, i) => 25+20*i)
                    .text(d => d.label);
            }
        } else if(props.view === 4 && props.arg === "line"){
           if(props.placeFormat.length === 2){
                legendBar.selectAll(".point_label_hos")
                    .remove();

                legendBar.selectAll(".point_label_nonhos")
                    .remove();

                legendBar.selectAll(".place_format")
                    .remove();

                legendBar.append('line')
                    .attr('class', 'place_format')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 20)
                    .attr("x2", 40)
                    .attr("y2", 20);

                legendBar.append('line')
                    .attr('class', 'place_format')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    // .style("stroke-dasharray", ("5, 5"))
                    .attr("x1", 0)
                    .attr("y1", 40)
                    .attr("x2", 40)
                    .attr("y2", 40);

                legendBar.append('circle')
                    .attr('class', 'point_label_hos')
                    .attr('fill', "black")
                    .attr('r', 6)
                    .attr('cx', 20)
                    .attr('cy', 20);
        
                legendBar.append('circle')
                        .attr('class', 'point_label_nonhos')
                        .style("stroke", "black")
                        .attr('r', 5)
                        .style("fill", "white")
                        .style("stroke-width", "2px")
                        .attr('cx', 20)
                        .attr('cy', 40);

                legendBar.selectAll('.label')
                    .data(props.placeFormat)
                    .join('text')
                    .attr('class', 'label')
                    .attr("x", (d, i) => 50)
                    .attr("y", (d, i) => 25+20*i)
                    .text(d => d);
            } else if(props.placeFormat.length === 1){
                legendBar.selectAll(".point_label_hos")
                    .remove();

                legendBar.selectAll(".point_label_nonhos")
                    .remove();

                legendBar.selectAll(".place_format")
                    .remove();

                legendBar.append('line')
                    .attr('class', 'place_format')
                    .style("stroke", color)
                    .style("stroke-width", 3)
                    .attr("x1", 0)
                    .attr("y1", 20)
                    .attr("x2", 40)
                    .attr("y2", 20);

                if(props.placeFormat.includes('เสียชีวิตในสถานพยาบาล')){
                    legendBar.append('circle')
                    .attr('class', 'point_label_hos')
                    .attr('fill', "black")
                    .attr('r', 6)
                    .attr('cx', 20)
                    .attr('cy', 20);
                } else {
                    legendBar.append('circle')
                    .attr('class', 'point_label_nonhos')
                    .style("stroke", "black")
                    .attr('r', 5)
                    .style("fill", "white")
                    .style("stroke-width", "2px")
                    .attr('cx', 20)
                    .attr('cy', 20);
                }

                legendBar.selectAll('.label')
                    .data(props.placeFormat)
                    .join('text')
                    .attr('class', 'label')
                    .attr("x", (d, i) => 50)
                    .attr("y", (d, i) => 25+20*i)
                    .text(d => d);
            }
            else {
                legendBar.selectAll(".place_format")
                .remove();

                legendBar.selectAll(".point_label_hos")
                .remove();

                legendBar.selectAll(".point_label_nonhos")
                .remove();

                legendBar.selectAll(".label")
                .remove();  
            }
        }  else if(props.view === 4 && props.arg === "shape"){
            var size = 70;

            var star = d3.symbol()
                .type(d3.symbolStar)
                .size(size);
            
            if(props.CODFormat.includes("กลุ่มโรคติดเชื้อ, ความผิดปกติในมารดาและปริกำเนิด และ ภาวะโภชนาการบกพร่อง")
            && (props.CODFormat.includes("โรคไม่ติดต่อ")
            || props.CODFormat.includes("การบาดเจ็บ")
            || props.CODFormat.includes("ไม่ทราบสาเหตุการตาย"))){

                legendBar.selectAll(".label_first")
                .remove();

                legendBar.selectAll(".first_shape")
                .remove();

                legendBar.selectAll(".shape_label")
                .remove();
                                
                legendBar.selectAll(".label")
                .remove();

                const label_data = [{"label":"กลุ่มโรคติดเชื้อ,ความผิดปกติ"},
                    {"label":"ในมารดาและปริกำเนิด"},
                    {"label":"และ ภาวะโภชนาการบกพร่อง"}];

                legendBar.append("path")
                    .attr('class', 'first_shape')
                    .attr("d", star)
                    .attr("stroke", color)
                    .attr("fill", color)
                    .attr("transform", function(d) { return "translate(" + 10 + "," + 20 + ")"; });
                    
                legendBar.selectAll('.label_first')
                    .data(label_data)
                    .join('text')
                    .attr('class', 'label_first')
                    .attr("x", (d, i) => 30)
                    .attr("y", (d, i) => 25+20*i)
                    .text(d => d.label);

                var shape_symbol = d3.symbol().type(function(d) { 
                    if(d.zeroOrOne == 0) {
                        return d3.symbolTriangle;
                    }
                    else if(d.zeroOrOne == 1) {
                        return d3.symbolCross;
                    }
                    else return d3.symbolSquare;
                }).size(size);

                if(props.CODFormat.includes("โรคไม่ติดต่อ")
                && props.CODFormat.includes("การบาดเจ็บ")
                && props.CODFormat.includes("ไม่ทราบสาเหตุการตาย")){
                    var label_data_other = [{"label":"โรคไม่ติดต่อ"},
                    {"label":"การบาดเจ็บ"},
                    {"label":"ไม่ทราบสาเหตุการตาย"}]
                    var shape_data = [{"zeroOrOne" : 0 }, {"zeroOrOne" : 1 }, {"zeroOrOne" : 2 }];
                } else if (!(props.CODFormat.includes("โรคไม่ติดต่อ"))
                && props.CODFormat.includes("การบาดเจ็บ")
                && props.CODFormat.includes("ไม่ทราบสาเหตุการตาย")){
                    var label_data_other = [
                    {"label":"การบาดเจ็บ"},
                    {"label":"ไม่ทราบสาเหตุการตาย"}]
                    var shape_data = [{"zeroOrOne" : 1 }, {"zeroOrOne" : 2 }];
                } else if (props.CODFormat.includes("โรคไม่ติดต่อ")
                && !(props.CODFormat.includes("การบาดเจ็บ"))
                && props.CODFormat.includes("ไม่ทราบสาเหตุการตาย")){
                    var label_data_other = [{"label":"โรคไม่ติดต่อ"},
                    {"label":"ไม่ทราบสาเหตุการตาย"}]
                    var shape_data = [{"zeroOrOne" : 0 }, {"zeroOrOne" : 2 }];
                } else if (props.CODFormat.includes("โรคไม่ติดต่อ")
                && props.CODFormat.includes("การบาดเจ็บ")
                && !(props.CODFormat.includes("ไม่ทราบสาเหตุการตาย"))){
                    var label_data_other = [{"label":"โรคไม่ติดต่อ"},
                    {"label":"การบาดเจ็บ"}]
                    var shape_data = [{"zeroOrOne" : 0 }, {"zeroOrOne" : 1 }];
                } else if (props.CODFormat.includes("โรคไม่ติดต่อ")
                && !(props.CODFormat.includes("การบาดเจ็บ"))
                && !(props.CODFormat.includes("ไม่ทราบสาเหตุการตาย"))){
                    var label_data_other = [{"label":"โรคไม่ติดต่อ"}]
                    var shape_data = [{"zeroOrOne" : 0 }];
                } else if (!(props.CODFormat.includes("โรคไม่ติดต่อ"))
                && props.CODFormat.includes("การบาดเจ็บ")
                && !(props.CODFormat.includes("ไม่ทราบสาเหตุการตาย"))){
                    var label_data_other = [{"label":"การบาดเจ็บ"}]
                    var shape_data = [{"zeroOrOne" : 1 }];
                } else {
                    var label_data_other = [
                    {"label":"ไม่ทราบสาเหตุการตาย"}]
                    var shape_data = [{"zeroOrOne" : 2 }];
                }

                legendBar.selectAll(".shape_label")
                .data(shape_data)
                .join("path")
                .attr('class', 'shape_label')
                .attr("d", d => shape_symbol(d))
                .attr("stroke", color)
                .attr("fill", color)
                .attr("transform", function(d,i) {
                    const y = 90+20*i
                    return "translate(" + 10 + "," + y + ")"; });

                legendBar.selectAll('.label')
                .data(label_data_other)
                .join('text')
                .attr('class', 'label')
                .attr("x", (d, i) => 30)
                .attr("y", (d, i) => 95+20*i)
                .text(d => d.label);

            } else if(!(props.CODFormat.includes("กลุ่มโรคติดเชื้อ, ความผิดปกติในมารดาและปริกำเนิด และ ภาวะโภชนาการบกพร่อง"))
            && (props.CODFormat.includes("โรคไม่ติดต่อ")
            || props.CODFormat.includes("การบาดเจ็บ")
            || props.CODFormat.includes("ไม่ทราบสาเหตุการตาย"))){
                
                legendBar.selectAll(".label_first")
                .remove();

                legendBar.selectAll(".first_shape")
                .remove();

                legendBar.selectAll(".shape_label")
                .remove();
                                
                legendBar.selectAll(".label")
                .remove();
                
                var shape_symbol = d3.symbol().type(function(d) { 
                    if(d.zeroOrOne == 0) {
                        return d3.symbolTriangle;
                    }
                    else if(d.zeroOrOne == 1) {
                        return d3.symbolCross;
                    }
                    else return d3.symbolSquare;
                }).size(size);

                if(props.CODFormat.includes("โรคไม่ติดต่อ")
                && props.CODFormat.includes("การบาดเจ็บ")
                && props.CODFormat.includes("ไม่ทราบสาเหตุการตาย")){
                    var label_data_other = [{"label":"โรคไม่ติดต่อ"},
                    {"label":"การบาดเจ็บ"},
                    {"label":"ไม่ทราบสาเหตุการตาย"}]
                    var shape_data = [{"zeroOrOne" : 0 }, {"zeroOrOne" : 1 }, {"zeroOrOne" : 2 }];
                } else if (!(props.CODFormat.includes("โรคไม่ติดต่อ"))
                && props.CODFormat.includes("การบาดเจ็บ")
                && props.CODFormat.includes("ไม่ทราบสาเหตุการตาย")){
                    var label_data_other = [
                    {"label":"การบาดเจ็บ"},
                    {"label":"ไม่ทราบสาเหตุการตาย"}]
                    var shape_data = [{"zeroOrOne" : 1 }, {"zeroOrOne" : 2 }];
                } else if (props.CODFormat.includes("โรคไม่ติดต่อ")
                && !(props.CODFormat.includes("การบาดเจ็บ"))
                && props.CODFormat.includes("ไม่ทราบสาเหตุการตาย")){
                    var label_data_other = [{"label":"โรคไม่ติดต่อ"},
                    {"label":"ไม่ทราบสาเหตุการตาย"}]
                    var shape_data = [{"zeroOrOne" : 0 }, {"zeroOrOne" : 2 }];
                } else if (props.CODFormat.includes("โรคไม่ติดต่อ")
                && props.CODFormat.includes("การบาดเจ็บ")
                && !(props.CODFormat.includes("ไม่ทราบสาเหตุการตาย"))){
                    var label_data_other = [{"label":"โรคไม่ติดต่อ"},
                    {"label":"การบาดเจ็บ"}]
                    var shape_data = [{"zeroOrOne" : 0 }, {"zeroOrOne" : 1 }];
                } else if (props.CODFormat.includes("โรคไม่ติดต่อ")
                && !(props.CODFormat.includes("การบาดเจ็บ"))
                && !(props.CODFormat.includes("ไม่ทราบสาเหตุการตาย"))){
                    var label_data_other = [{"label":"โรคไม่ติดต่อ"}]
                    var shape_data = [{"zeroOrOne" : 0 }];
                } else if (!(props.CODFormat.includes("โรคไม่ติดต่อ"))
                && props.CODFormat.includes("การบาดเจ็บ")
                && !(props.CODFormat.includes("ไม่ทราบสาเหตุการตาย"))){
                    var label_data_other = [{"label":"การบาดเจ็บ"}]
                    var shape_data = [{"zeroOrOne" : 1 }];
                } else {
                    var label_data_other = [
                    {"label":"ไม่ทราบสาเหตุการตาย"}]
                    var shape_data = [{"zeroOrOne" : 2 }];
                }

                legendBar.selectAll(".shape_label")
                .data(shape_data)
                .join("path")
                .attr('class', 'shape_label')
                .attr("d", d => shape_symbol(d))
                .attr("stroke", color)
                .attr("fill", color)
                .attr("transform", function(d,i) {
                    const y = 20+20*i
                    return "translate(" + 10 + "," + y + ")"; });

                legendBar.selectAll('.label')
                .data(label_data_other)
                .join('text')
                .attr('class', 'label')
                .attr("x", (d, i) => 30)
                .attr("y", (d, i) => 25+20*i)
                .text(d => d.label);

            } else if(props.CODFormat.includes("กลุ่มโรคติดเชื้อ, ความผิดปกติในมารดาและปริกำเนิด และ ภาวะโภชนาการบกพร่อง")
            && !(props.CODFormat.includes("โรคไม่ติดต่อ"))
            && !(props.CODFormat.includes("การบาดเจ็บ"))
            && !(props.CODFormat.includes("ไม่ทราบสาเหตุการตาย"))){

                legendBar.selectAll(".label_first")
                .remove();

                legendBar.selectAll(".first_shape")
                .remove();
   
                legendBar.selectAll(".shape_label")
                .remove();
                                
                legendBar.selectAll(".label")
                .remove();

                const label_data = [{"label":"กลุ่มโรคติดเชื้อ,ความผิดปกติ"},
                {"label":"ในมารดาและปริกำเนิด"},
                {"label":"และ ภาวะโภชนาการบกพร่อง"}];

            legendBar.append("path")
                .attr('class', 'first_shape')
                .attr("d", star)
                .attr("stroke", color)
                .attr("fill", color)
                .attr("transform", function(d) { return "translate(" + 10 + "," + 20 + ")"; });
                
            legendBar.selectAll('.label_first')
                .data(label_data)
                .join('text')
                .attr('class', 'label_first')
                .attr("x", (d, i) => 30)
                .attr("y", (d, i) => 25+20*i)
                .text(d => d.label);
            }else {

                legendBar.selectAll(".label_first")
                    .remove();

                legendBar.selectAll(".first_shape")
                    .remove();
                
                legendBar.selectAll(".shape_label")
                .remove();
                                
                legendBar.selectAll(".label")
                .remove();

            }
        }
    }

    useEffect(() => {
        const {legendBar, graphWidth, graphHeight} = draw();
        update(legendBar, graphWidth, graphHeight);
    }, [props.selectedGender, props.placeFormat, props.CODFormat]);
    return ( 
        <svg width={graphWidthActual} height={graphHeightActual}>
            <g ref={legendLineShapeRef} className="legend_line_shape" />
        </svg>
     );
}
 
export default Legend_line_shape;